import NewsTag from 'models/tag/NewsTag';

import TagBaseService from 'services/tag/TagBaseService';

export default class NewsTagService extends TagBaseService {
	toModel(tag) {
		return new NewsTag(tag);
	}
}
